module.exports = __webpack_public_path__ + "img/logo-text-color.6dab418a.png";